import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ILearnActionRepository } from '../../repositories/interfaces/iLearnActionRepository';
import { ILearnActionResponse, ILearnEventPayload } from '../../../entity/interface/iLearnAction';

export interface ILearnEventUseCase {
    execute(apiKey: string, paylod: ILearnEventPayload, identityToken: string): Promise<ILearnActionResponse>;
}

export class LearnEventUseCase implements ILearnEventUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get learnEventRepository(): ILearnActionRepository {
        return container.resolve<ILearnActionRepository>(DI.REPOSITORIES.ILearnActionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, paylod: ILearnEventPayload, identityToken: string): Promise<any> {
        return this.learnEventRepository.learnEvent(apiKey, paylod, identityToken);
    }
}
